import React from 'react';

import { Button } from '@components/Button/Button';
import type { IFeatureItem } from '@components/FeaturesList/FeatureItem/FeatureItem';
import { FeatureItem } from '@components/FeaturesList/FeatureItem/FeatureItem';
import { externalRoutes } from '@routes';

import styles from './FeaturesList.module.scss';
import ArrowDown from '@icons/arrowDown.svg';

export interface IProps {
  data: IFeatureItem[];
  withClientPanelButton?: boolean;
}

export const FeaturesList: React.FC<IProps> = ({ data, withClientPanelButton = false }) => {
  const [activeIndex, setActiveIndex] = React.useState<string | null>(null);
  const halfLength = Math.ceil(data.length / 2);
  const firstHalf = data.slice(0, halfLength);
  const secondHalf = data.slice(halfLength);

  return (
    <div>
      <div className={styles.wrapper}>
        <div className={styles.column}>
          {firstHalf.map((item, index) => (
            <FeatureItem
              key={item.title}
              description={item.description}
              href={item.href}
              icon={item.icon}
              isOpen={activeIndex === `list1-${index}`}
              title={item.title}
              onToggle={() =>
                setActiveIndex(activeIndex === `list1-${index}` ? null : `list1-${index}`)
              }
            />
          ))}
        </div>
        <div className={styles.column}>
          {secondHalf.map((item, index) => (
            <FeatureItem
              key={item.title}
              description={item.description}
              href={item.href}
              icon={item.icon}
              isOpen={activeIndex === `list2-${index}`}
              title={item.title}
              onToggle={() => {
                setActiveIndex(activeIndex === `list2-${index}` ? null : `list2-${index}`);
              }}
            />
          ))}
        </div>
      </div>
      <div className={styles.buttonsWrapper}>
        <Button
          href={externalRoutes.client.knowledgeBase}
          size="md"
          theme="button"
          variant="secondary"
          external
          noIcon
        >
          Browse full documentation
        </Button>
        {withClientPanelButton && (
          <Button
            className={styles.learn}
            href="#client-panel"
            icon={<ArrowDown />}
            spacing="lg"
            theme="link"
          >
            More about customisation
          </Button>
        )}
      </div>
    </div>
  );
};
